import 'vxe-table/lib/style.css'
import 'vxe-table-plugin-element/dist/style.css'
import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import i18n from '@/i18n'

VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => {
    return i18n.t(key, args)
  },
  table: { scrollY: { enabled: false } },
})

VXETable.use(VXETablePluginElement)

// 创建一个简单输入框渲染
VXETable.renderer.add('dict-select', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, { row, column }) {
    const props = renderOpts.props || {}
    const onTextChange = (val) => {
      row[`${column.property}Text`] = val
    }
    return [
      <dict-select
        v-model={row[column.property]}
        {...{ props }}
        {...{ on: { 'update:selectedLabel': onTextChange } }}
      />
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    return [<span>{row[`${column.property}Text`]}</span>]
  }
})

// 创建一个简单输入框渲染
// VXETable.renderer.add('org-cascader', {
//   // 可编辑激活模板
//   renderEdit(h, renderOpts, { row, column }) {
//     const props = renderOpts.props || {}
//     const onLastValueChange = (val) => {
//       row[`${column.property}Val`] = val
//     }
//     const onValueStringChange = (val) => {
//       row[`${column.property}All`] = val
//     }
//     const onPathLabelsChange = (val) => {
//       row[`${column.property}PathLabels`] = val
//     }
//     return [
//       <org-cascader
//         v-model={row[column.property]}
//         {...{
//           valueString: row['orgAllCode'],
//           lastValue: row[column.property],
//           pathValue: row[column.property + 'PathLabels'],
//         }}
//         {...{
//           on: {
//             'update:lastValue': onLastValueChange,
//             'update:valueString': onValueStringChange,
//             'update:pathLabels': onPathLabelsChange,
//           },
//         }}
//       />,
//     ]
//   },
//   // 可编辑显示模板
//   renderCell(h, renderOpts, { row, column }) {
//     return [<span>{row[`${column.property}PathLabels`]}</span>]
//   },
// })

// 创建一个简单输入框渲染
VXETable.renderer.add('date-picker', {
  // 可编辑激活模板
  renderEdit(h, renderOpts, { row, column }) {
    const props = renderOpts.props || {}
    const onValueChange = (val) => {
      row[`${column.property}`] = val
    }
    return [
      <el-date-picker
        v-model={row[column.property]}
        {...{ props }}
        {...{
          on: {
            change: onValueChange
          }
        }}
      />
    ]
  },
  // 可编辑显示模板
  renderCell(h, renderOpts, { row, column }) {
    return [<span>{row[`${column.property}`]}</span>]
  }
})

export default {
  install(Vue) {
    Vue.use(VXETable)
  }
}
